/* eslint-disable */
import { RINGS_TYPE } from '@ringcentral-integration/commons/modules/RingtoneConfiguration/const';
export default {
  [RINGS_TYPE.Phone_Ring1]: 'Toque de telefone 1',
  [RINGS_TYPE.Phone_Ring2]: 'Toque de telefone 2',
  [RINGS_TYPE.Acoustic_Dreams]: 'Acústico',
  [RINGS_TYPE.Air_Raid]: 'Ataque aéreo',
  [RINGS_TYPE.Allusive]: 'Alusivo',
  [RINGS_TYPE.Attention]: 'Atenção',
  [RINGS_TYPE.Blub_Blub]: 'Blub Blub',
  [RINGS_TYPE.Buzzy]: 'Buzzy',
  [RINGS_TYPE.Channel_Open]: 'Canal aberto',
  [RINGS_TYPE.Contemplation]: 'Contemplação',
  [RINGS_TYPE.Crystal_Ball]: 'Cristal',
  [RINGS_TYPE.Disco]: 'Discoteca',
  [RINGS_TYPE.Door_Bell]: 'Campainha',
  [RINGS_TYPE.Fairy]: 'Fada',
  [RINGS_TYPE.Fast_Bells]: 'Sinos rápidos',
  [RINGS_TYPE.High_Gong]: 'Gong alto',
  [RINGS_TYPE.Immersion]: 'Imersão',
  [RINGS_TYPE.Indeed]: 'Efeito',
  [RINGS_TYPE.Lazy_Day]: 'Relaxamento',
  [RINGS_TYPE.Neural_Funk]: 'Neurônio',
  [RINGS_TYPE.Nice]: 'Legal',
  [RINGS_TYPE.Ring]: 'Toque',
  [RINGS_TYPE.Ringing_Bells]: 'Sinos tocando',
  [RINGS_TYPE.Simple]: 'Simples',
  [RINGS_TYPE.Soothing]: 'Tranquilizante',
  [RINGS_TYPE.Sunshine]: 'Luz do sol',
  [RINGS_TYPE.Off]: 'Desativado',
  add: 'Adicionar',
  delete: 'Excluir',
  play: 'Reproduzir',
  cancel: 'Cancelar',
  confirmToDelete: 'Excluir {name}?',
} as const;

// @key: @#@"[RINGS_TYPE.Phone_Ring1]"@#@ @source: @#@"Phone Ring 1"@#@
// @key: @#@"[RINGS_TYPE.Phone_Ring2]"@#@ @source: @#@"Phone Ring 2"@#@
// @key: @#@"[RINGS_TYPE.Acoustic_Dreams]"@#@ @source: @#@"Acoustic Dreams"@#@
// @key: @#@"[RINGS_TYPE.Air_Raid]"@#@ @source: @#@"Air Raid"@#@
// @key: @#@"[RINGS_TYPE.Allusive]"@#@ @source: @#@"Allusive"@#@
// @key: @#@"[RINGS_TYPE.Attention]"@#@ @source: @#@"Attention"@#@
// @key: @#@"[RINGS_TYPE.Blub_Blub]"@#@ @source: @#@"Blub Blub"@#@
// @key: @#@"[RINGS_TYPE.Buzzy]"@#@ @source: @#@"Buzzy"@#@
// @key: @#@"[RINGS_TYPE.Channel_Open]"@#@ @source: @#@"Channel Open"@#@
// @key: @#@"[RINGS_TYPE.Contemplation]"@#@ @source: @#@"Contemplation"@#@
// @key: @#@"[RINGS_TYPE.Crystal_Ball]"@#@ @source: @#@"Crystal Ball"@#@
// @key: @#@"[RINGS_TYPE.Disco]"@#@ @source: @#@"Disco"@#@
// @key: @#@"[RINGS_TYPE.Door_Bell]"@#@ @source: @#@"Door Bell"@#@
// @key: @#@"[RINGS_TYPE.Fairy]"@#@ @source: @#@"Fairy"@#@
// @key: @#@"[RINGS_TYPE.Fast_Bells]"@#@ @source: @#@"Fast Bells"@#@
// @key: @#@"[RINGS_TYPE.High_Gong]"@#@ @source: @#@"High Gong"@#@
// @key: @#@"[RINGS_TYPE.Immersion]"@#@ @source: @#@"Immersion"@#@
// @key: @#@"[RINGS_TYPE.Indeed]"@#@ @source: @#@"Indeed"@#@
// @key: @#@"[RINGS_TYPE.Lazy_Day]"@#@ @source: @#@"Lazy Day"@#@
// @key: @#@"[RINGS_TYPE.Neural_Funk]"@#@ @source: @#@"Neural Funk"@#@
// @key: @#@"[RINGS_TYPE.Nice]"@#@ @source: @#@"Nice"@#@
// @key: @#@"[RINGS_TYPE.Ring]"@#@ @source: @#@"Ring"@#@
// @key: @#@"[RINGS_TYPE.Ringing_Bells]"@#@ @source: @#@"Ringing Bells"@#@
// @key: @#@"[RINGS_TYPE.Simple]"@#@ @source: @#@"Simple"@#@
// @key: @#@"[RINGS_TYPE.Soothing]"@#@ @source: @#@"Soothing"@#@
// @key: @#@"[RINGS_TYPE.Sunshine]"@#@ @source: @#@"Sunshine"@#@
// @key: @#@"[RINGS_TYPE.Off]"@#@ @source: @#@"Off"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"delete"@#@ @source: @#@"Delete"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirmToDelete"@#@ @source: @#@"Delete {name}?"@#@
